function RangeSlider(RangeSlider) {
  var self = this;
  //var RangeSlider = document.querySelector(selector);

  if (!RangeSlider) return;
  var SliderThumb = RangeSlider.querySelector('[data-range-slider-thumb]');
  var SliderTrack = RangeSlider.querySelector('[data-range-slider-track]');
  var SliderTrackFill = RangeSlider.querySelector('[data-range-slider-track-fill]');
  var ClickArea = RangeSlider.querySelector('[data-range-slider]');
  var SliderPoints = RangeSlider.querySelectorAll('[data-range-slider-point]');
  var SliderCheckPoints = RangeSlider.querySelectorAll('[data-range-slider-checkpoint]');
  var totalPoints = SliderPoints.length;

  function findValueFromTrackFill(trackFillWidth) {
    var totalWidth = SliderTrack.clientWidth,
      onePercentWidth = totalWidth / 100,
      modifier = 100 / (totalPoints - 1);
    value = Math.round(trackFillWidth / onePercentWidth / modifier, 2);
    return value;
  }

  function updateSelectedValue(newValue) {
    SliderPoints.forEach(function (sliderPoint) {
      sliderPoint.classList.remove('active');
    });
    SliderPoints.forEach((point, index) => {
      if (index === newValue) {
        point.classList.add('active');
      } else {
        point.classList.remove('active');
      }
    });

    var event = new Event('range-slider-changed');
    window.dispatchEvent(event);
  }

  function updateHighlightedTrack(newPosition) {
    newPosition = (newPosition / (totalPoints - 1)) * 100;
    newPosition = newPosition + '%';
    SliderTrackFill.style.width = newPosition;
  }

  function setupDrag(element, initialXPosition, touch = false) {
    SliderTrackFill.classList.add('stopAnimation');
    var trackWidth = SliderTrackFill.clientWidth;
    window.trackWidth = trackWidth;
    window.initialXPosition = initialXPosition;

    var newValue = findValueFromTrackFill(trackWidth);
    updateSelectedValue(newValue);

    if (touch) {
      element.addEventListener('touchmove', mouseMoveFn);
    } else {
      element.addEventListener('mousemove', mouseMoveFn);
    }
  }

  function mouseMoveFn() {
    var trackWidth = window.trackWidth;
    var initialXPosition = window.initialXPosition;
    var clientX = event.type === 'touchmove' ? event.touches[0].clientX : event.clientX;

    var newPosition = trackWidth + clientX - initialXPosition;
    imitateNewValue(newPosition);

    newValue = findValueFromTrackFill(SliderTrackFill.clientWidth);
    updateSelectedValue(newValue);
  }

  function finishDrag(element, touch = false) {
    SliderTrackFill.classList.remove('stopAnimation');
    if (touch) {
      element.removeEventListener('touchmove', mouseMoveFn);
    } else {
      element.removeEventListener('mousemove', mouseMoveFn);
    }
    const newValue = findValueFromTrackFill(SliderTrackFill.clientWidth);
    updateSliderValue(newValue);
  }

  this.updateSliderValue = function (newValue) {
    updateSelectedValue(newValue);
    updateHighlightedTrack(newValue);
    self.value = newValue;
  };

  this.imitateNewValue = function (XPosition) {
    SliderTrackFill.classList.add('stopAnimation');
    if (XPosition > SliderTrack.clientWidth) {
      XPosition = SliderTrack.clientWidth;
    }
    SliderTrackFill.style.width = XPosition + 'px';
  };

  ClickArea.addEventListener('mousedown', function (e) {
    var target = e.target;
    if (target.hasAttribute('data-range-slider-thumb')) {
      return false;
    }

    var offsetX = e.offsetX;

    if (target.hasAttribute('data-range-slider-checkpoint-end')) {
      offsetX = 9999;
    }

    self.imitateNewValue(offsetX);
    setupDrag(this, e.clientX);
  });

  ClickArea.addEventListener('mouseup', function (e) {
    finishDrag(ClickArea);
  });

  SliderPoints.forEach(function (point) {
    point.addEventListener('mousedown', function (e) {
      e.stopPropagation();
      var XPos = point.offsetLeft + point.offsetWidth / 2;
      self.imitateNewValue(XPos);
      setupDrag(ClickArea, e.clientX);
    });
  });

  SliderThumb.addEventListener('mousedown', function (e) {
    e.stopPropagation();
    setupDrag(SliderThumb, e.clientX);
  });

  SliderThumb.addEventListener('touchstart', function (e) {
    e.stopPropagation();
    setupDrag(SliderThumb, e.touches[0].clientX, true);
  });

  SliderThumb.addEventListener('mouseup', function (e) {
    finishDrag(SliderThumb);
  });

  SliderThumb.addEventListener('touchend', function (e) {
    finishDrag(SliderThumb, true);
  });

  window.addEventListener('range-slider-update', () => {
    var newValue = findValueFromTrackFill(event.detail);
    updateSliderValue(newValue);
  });
}

document.addEventListener('alpine:init', () => {
  Alpine.data('rechargePopup', (product = {}, id) => ({
    open: false,
    open2: false,
    id: id,
    variant_id: 0,
    selling_plan_id: 0,
    open_selector: '[data-change-subscription]',

    init() {
      this.open = false;
      this.open2 = false;
      document.body.classList.remove('modal-open');
      document.body.appendChild(this.$el);
      this.initOpeners();
      setTimeout(() => {
        document.body.classList.remove('recharge-modal-open');
      }, 1000);
    },

    initOpeners() {
      const openers = document.querySelectorAll(this.open_selector);
      if (!openers.length) {
        return;
      }

      openers.forEach((opener) => {
        opener.addEventListener('click', () => {
          event.preventDefault();
          document.querySelector('body').classList.add('recharge-modal-open');
          const popup_id = parseInt(opener.dataset.changeSubscription);
          if (popup_id === id) {
            this.openPopup(popup_id);
          }
        });
      });
    },

    handleFreqSelection() {
      if (this.open) {
        const selected_freq = this.$refs.freqs.querySelector('.active');
        if (!selected_freq) {
          return;
        }
        this.selling_plan_id = parseInt(selected_freq.dataset.deliveryId);
        this.$el.querySelector('.rp__button-subscribe').dataset.popupChangeId = this.selling_plan_id;
      }
    },

    closePopup() {
      if (!this.open) {
        return;
      }

      if (event) {
        const isOpener = event.target.closest(this.open_selector) ? true : false;

        if (isOpener) {
          return;
        }
      }

      this.open = false;
      this.open2 = false;
      document.body.classList.remove('modal-open');
      setTimeout(() => {
        document.body.classList.remove('recharge-modal-open');
      }, 1000);
    },

    async wait(time) {
      await new Promise((resolve) => setTimeout(resolve, time));
    },

    async openPopup(popup_id) {
      if (this.open) {
        return;
      }

      document.body.classList.add('modal-open');

      this.open = true;

      await this.wait(600);

      this.open2 = true;

      let fillSlider = this.$el.querySelector('[data-range-slider-track-fill]');

      const slider = this.$el.querySelector('[data-range-slider-container]');
      RangeSlider(slider);

      setTimeout(() => {
        if (fillSlider) {
          this.$dispatch('range-slider-update', fillSlider.clientWidth);
        }
      }, 1000);
    },
  }));
});
